import React from "react";
import { Text } from "@salestrak/ui";
import { DEFAULT_ISSUE_NAME } from "../activity-types";

export function CreationChunk() {
  return <Text size="sm">created this {DEFAULT_ISSUE_NAME.toLowerCase()}</Text>;
}
